<style src="./ItemPricing.scss" lang="scss"></style>
<template>
  <main class="item-pricing">
    <content-header path="Resultado"/>

    <section class="list-container">
      <table>
        <thead>
          <group-header
            @toggle-column="toggleColumns"
            @add-column="addColumn" />
          <column-header
            ref="ColumnHeader"
            :active-filter="filters.columnFilters"
            :active-dynamic-filter="filters.dynamicColumnFilter"
            @header-view-contraction="setColumnContraction"
            @open-edition="openPanelColumnEdition"
            @filter-dynamic-value="filterDynamicColumnByValue"
            @filter-value="filterByColumnValue" />
        </thead>

        <list-items
          v-model="filteredList"
          :proposal-margin="configPanel.proposalMargin"
          :column-contraction="headerColumnContraction"
          @edit-cost="openPanelEditCost" />
        
      </table>
      <div
        class="addcolumn">
        <button
          type="button"
          class="addbutton"
          @click="addColumn">
          <icon-add class="icon" />
        </button>
      </div>
    </section>
    <right-side-panel
      ref="rspEditCost"
      title="Editar Custo"
      width="600px">
      <cost-edition
        :info="costEdition"
        @refresh-edition="refreshCostEdition" />
    </right-side-panel>

    <right-side-panel
      ref="rspColumnEdition"
      :title="columnEdition.name"
      width="600px">
      <column-edition
        :column-id="columnEdition.id"
        :filter-list="filters.columnFilters"
        @filter-value="filterByColumnValue" />
    </right-side-panel>
  </main>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import ColumnHeader from './components/column-header/ColumnHeader'
import GroupHeader from './components/group-header/GroupHeader'
import ListItems from './components/list-items/ListItems'
import IsClosedTask from '@/components/foundation/is-closed-task/IsClosedTask'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import CostEdition from './components/cost-edition/CostEdition'
import HeaderPanel from './components/header-panel/HeaderPanel'
import ColumnEdition from './components/column-edition/ColumnEdition'
import FilterItems from './helpers/FilterItems'
import { IconAdd } from '@/components/primitives/icons'

export default {
  name: 'ItemPricing',
  components: {
    ContentHeader,
    ListItems,
    ColumnHeader,
    GroupHeader,
    IsClosedTask,
    RightSidePanel,
    CostEdition,
    HeaderPanel,
    ColumnEdition,
    IconAdd
  },
  data () {
    return {
      isStageOpened: false,
      filters: {
        searchText: '',
        wasNotAssociated: false,
        wasQuoted: false,
        wasAssociated: false,
        haveProposal: false,
        dynamicColumnFilter: {},
        columnFilters: {
          number: {
            filterType: '0',
            filterValue: []
          },
          strictToME: {
            filterType: 'BOOLEAN',
            filterValue: ['TRUE', 'FALSE']
          },
          isPriceGuaranted: {
            filterType: 'BOOLEAN',
            filterValue: ['TRUE', 'FALSE']
          },
          quotationMap: {
            filterType: 'KEY',
            filterValue: ['avaliableQuotation', 'waitingResponseQuotation', 'rejectedQuotation', 'noSendedQuotation', 'noquoteQuotation']
          },
          guaranteed: {
            filterType: '0',
            filterValue: []
          },
          description: {
            filterType: '0',
            filterValue: []
          },
          unity: {
            filterType: '0',
            filterValue: []
          },
          costLab: {
            filterType: '0',
            filterValue: []
          },
          costUnit: {
            filterType: '0',
            filterValue: null
          },
          costTotal: {
            filterType: '0',
            filterValue: null
          },
          maxLab: {
            filterType: '0',
            filterValue: []
          },
          maxUnit: {
            filterType: '0',
            filterValue: null
          },
          maxTotal: {
            filterType: '0',
            filterValue: null
          },
          maxPerc: {
            filterType: '0',
            filterValue: null
          },
          estimatedUnit: {
            filterType: '0',
            filterValue: null
          },
          estimatedTotal: {
            filterType: '0',
            filterValue: null
          },
          estimatedPerc: {
            filterType: '0',
            filterValue: null
          },
          saleUnit: {
            filterType: '0',
            filterValue: null
          },
          saleTotal: {
            filterType: '0',
            filterValue: null
          },
          salePerc: {
            filterType: '0',
            filterValue: null
          },
          minimumUnit: {
            filterType: '0',
            filterValue: null
          },
          minimumTotal: {
            filterType: '0',
            filterValue: null
          },
          minimumPerc: {
            filterType: '0',
            filterValue: null
          }
        }
      },
      columnEdition: {
        id: 'costUnit',
        name: 'Custo - Valor Unitário'
      },
      headerColumnContraction: {
        costLab: false,
        costUnit: false,
        costTotal: false,
        maxLab: false,
        maxUnit: false,
        maxTotal: false,
        estimatedLab: false,
        estimatedUnit: false,
        estimatedTotal: false,
        proposalUnit: false,
        proposalTotal: false,
        minimumUnit: false,
        minimumTotal: false
      },
      costEditionIdx: null,
      costEdition: {}
    }
  },
  computed: {
    stage () {
      return this.$store.getters['Board/STAGE_BY_NAME']('Resultado')
    },
    items () {
      return this.$store.getters['ItemPricing/GET_ALL_LIST']
    },
    eventId () {
      return this.$route.params.id
    },
    configPanel () {
      return this.$store.getters['ItemPricing/CONFIG_PANEL']
    },
    filteredList () {
      return this.$store.getters['ItemPricing/FILTERED_LIST']
    }
  },
  watch: {
    items: {
      handler () {
        this.applyFilter()
      },
      immediate: true
    }
  },
  mounted () {
    this.eraseHistory()
    this.listAllItems()
  },
  methods: {
    async listAllItems () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      await this.$store.dispatch('ItemPricing/LIST_ALL_ITEMS', { eventId })
    },
    applyFilter () {
      const filterQuery = {
        items: this.items,
        filters: this.filters
      }
      const filteredList = FilterItems(filterQuery)
      this.$store.commit('ItemPricing/FILTERED_LIST', filteredList)
    },
    setColumnContraction (c) {
      this.headerColumnContraction = c
    },
    toggleColumns (columns) {
      this.$refs.ColumnHeader.toggleAllColumn(columns)
    },
    openPanelEditCost ({ item, itemIdx }) {
      this.costEditionIdx = itemIdx
      this.costEdition = item
      this.$refs.rspEditCost.showPanel()
    },
    refreshCostEdition () {
      this.costEdition = this.filteredList[this.costEditionIdx]
    },
    openPanelColumnEdition (item) {
      this.columnEdition.id = item.id
      this.columnEdition.name = item.name
      this.$refs.rspColumnEdition.showPanel()
    },
    filterHeader (filters) {
      const newFilters = Object.assign({}, this.filters, filters)
      this.filters = newFilters
      this.applyFilter()
    },
    filterByColumnValue (filters) {
      this.filters.columnFilters[filters.columnId].filterType = filters.filterType
      this.filters.columnFilters[filters.columnId].filterValue = filters.filterValue
      this.applyFilter()
    },
    eraseHistory () {
      this.$store.commit('ItemPricing/SET_LIST_ITEMS', { listItems: [] })
      this.$store.commit('ItemPricing/GROUP_FILTERS')
    },
    async addColumn () {
      const eventId = this.eventId
      await this.$store.dispatch('ItemPricing/ADD_COLUMN', {
        eventId
      })
    },
    filterDynamicColumnByValue (filters) {
      if (filters.filterType === '0') {
        delete this.filters.dynamicColumnFilter[filters.columnId]
      } else {
        this.filters.dynamicColumnFilter[filters.columnId] = {
          filterType: filters.filterType,
          filterValue: filters.filterValue
        }
      }
      this.applyFilter()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/view/item-pricing/ItemPricing.vue